import { FC } from 'react';

import classNames from 'classnames';

import 'components/Switch/Switch.less';

interface SwitchProps {
    onChange: () => void;
    value: boolean;
    disabled: boolean;
    warning?: boolean;
    qa: string;
}

const Switch: FC<SwitchProps> = ({ value = false, disabled = false, onChange, warning = false, qa }) => {
    return (
        <label className={classNames('switch', { [`switch_disabled`]: disabled })} data-qa={qa}>
            <input
                className={classNames('switch__state', { [`switch__state_warning`]: warning })}
                type="checkbox"
                checked={value}
                onChange={onChange}
                disabled={disabled}
            />
            <span className="switch__slider" />
        </label>
    );
};

export default Switch;
